import { HairCamApp } from './HairCamApp';

// Initialize the app when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new HairCamApp();
});

// Service worker will be registered automatically by Vite PWA plugin